<template>
    <div class="client-view">
        <div v-if="!isEditing">
                <p v-if="selectedClient?.data.avatar_file_name"><img :src="`/storage/clients_avatars/${selectedClient.data.avatar_file_name}`"
                    style="width:10em"></p> 
            </div>
            <div class="fw-bold col-md-4" v-if="isEditing">
                                <!-- Show uploaded preview -->
                                <img v-if="avatarUrl" :src="avatarUrl" alt="Preview Image"
                                    class="img-thumbnail"
                                    style="width: 150px; height: 150px; object-fit: cover; border-radius: 5px;">

                                <!-- Show existing profile image if no new file is uploaded -->
                                <img v-else-if="selectedClient.data.avatar_file_name" 
                                    :src="`/storage/clients_avatars/${selectedClient.data.avatar_file_name}`" 
                                    alt=""
                                    class="img-thumbnail"
                                    style="width: 150px; height: 100px; object-fit: cover; border-radius: 5px;">

                                <!-- File Input -->
                                <input type="file" @change="onFileChange" accept="image/*" class="form-control mb-4">
                            </div><br>
            <div class="supplier-info">
                <div class="info-row">
             <div class="info-item">

                <label>Title:</label>
                <input type="text" v-model="selectedClient.data.title" :disabled="!isEditing"  :class="{ 'enabled': isEditing}"/>

            </div>

            <div class="info-item">

<label>Nickname:</label>
<input type="text" v-model="selectedClient.data.nickname" :disabled="!isEditing"  :class="{ 'enabled': isEditing}"/>

</div>
             <div class="info-item">

                <label>Email:</label>
                <input type="text" v-model="formattedEmail" :disabled="!isEditing"  :class="{ 'enabled': isEditing}"/>

            </div>
             
        </div>
        
        <div class="info-row">
          
             <div class="info-item">

                <label>Phone:</label>
                <input 
  type="text" 
  v-model="formattedPhone" 
  :disabled="!isEditing"  
  :class="{ 'enabled': isEditing }"
/>


            </div>
            <div class="info-item">

<label>Postal code:</label>
<input type="text" v-model="formattedPostal" :disabled="!isEditing"  :class="{ 'enabled': isEditing}"/>

</div>
            

            <div class="info-item">

<label>Address:</label>
<input type="text" v-model="formattedAddress" :disabled="!isEditing"  :class="{ 'enabled': isEditing}"/>

</div>

        </div>
        
        <div class="info-row">
            <div class="info-item">

<label>Tax info:</label>
<input type="text" v-model="formattedTaxInfo" :disabled="!isEditing"  :class="{ 'enabled': isEditing}"/>

</div>

<div class="info-item">

<label>Occupation:</label>
<input type="text" v-model="formattedOccupation" :disabled="!isEditing"  :class="{ 'enabled': isEditing}"/>

</div>

<div class="info-item">

<label>Found us:</label>
<input type="text" v-model="formattedFoundUs" :disabled="!isEditing"  :class="{ 'enabled': isEditing}"/>

</div>

</div>
        
        <div class="info-row">
<div class="info-item">
    <label>Potential:</label>
                                <select v-model="selectedClient.data.potential" :class="{ 'enabled': isEditing}" :disabled="!isEditing"
                                aria-label="Potential">
                                <option value=""></option>
                                <option value="1">Ναι</option>
                                <option value="0">Όχι</option>
                            </select>
                            </div>
                            <div class="info-item">
                                <label>Paid</label>
                                <select  v-model="selectedClient.data.paid" aria-label="Paid" :class="{ 'enabled': isEditing}" :disabled="!isEditing">
                                <option value=""></option>
                                <option value="1">Ναι</option>
                                <option value="0">Όχι</option>
                            </select>
                            </div>
                            <div class="info-item">
                                <label>Pay Manager</label>
                                            <Select2 :options="allData.users" v-model="selectedClient.data.payManagerId"
                                                :settings="select2Settings"  :class="{ 'enabled': isEditing && selectedClient.data.paid == '1' }"
                                                :disabled="!isEditing || selectedClient.data.paid != '1'" />
                                        </div>
        </div>


</div>

<div class="actions">
<button @click="cancelEditing" class="cancel-btn" v-if="isEditing">CANCEL</button>
<button @click="startEditing" v-if="!isEditing && (superUser || canEditClient(selectedClient) || canEditAllClients)" class="edit-btn">EDIT</button>
<button class="save-btn" v-if="isEditing" @click="openConfirmationModal">SAVE</button>
</div>

<h4 class="fw-bolder">Projects</h4>
        <table id="projectTable" class="table table-hover align-middle mb-0 mis_table" style="width:100%">
            <thead>
                <tr>
                    
                    <th style="width:20%;">
                        <div>Project</div>
                    </th>
                    <th style="width:17%;">
                        <div>Creator</div>
                    </th>
                    <th style="width:17%;">
                        <div>Manager</div>
                    </th>
                    <th style="width:12%;">
                        <div>Start Date</div>
                    </th>
                    <th style="width:12%;">
                        <div>End Date</div>
                    </th>
                    <th style="width:15%;">
                        <div>Status</div>
                    </th>
                    <th class="no-after"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(project, index) in selectedClient.data.projects" :key="project.id" v-if="superUser || canViewAllProjects || canViewProject(project)">
                    
                    <!-- Project -->
                    <td class="centered-text">
                        <router-link :to="{ path: 'project', query: { id: project.id } }">
                            <span class="project-code">{{ project.code }}</span>
                        </router-link>
                    </td>
                    <!-- Creator -->
                    <td>{{ project.creator?.username || '' }}</td>
                    <!-- Manager -->
                    <td>{{ project.manager?.username || '' }}</td>
                    <td>{{ project.startDate || '' }}</td>

                    <td>{{ project.endDate || '' }}</td>

                    <!-- Status -->
                    <td>
                        <div class="dropdown-container">
                            <button class="dropbtn" :style="getStatusStyle(project.statusId)">
                                {{ project.status.description }}
                            </button>
                        </div>
                    </td>
                </tr>
                <tr v-if="!selectedClient.data.projects || selectedClient.data.projects.length === 0">
                    <td colspan="6" class="text-center">No projects available</td>
                </tr>
            </tbody>
        </table><br><br>

        <h4 class="fw-bolder">Client Contacts</h4>
        <table id="projectTable" class="table table-hover align-middle mb-0 mis_table" style="width:100%">
            <thead>
                <tr>
                    
                    <th style="width:23%;">
                        <div>Name</div>
                    </th>
                    <th style="width:17%;">
                        <div>Phone</div>
                    </th>
                    <th style="width:15%;">
                        <div>Email</div>
                    </th>
                    <th style="width:17%;">
                        <div>Address</div>
                    </th>
                    <th style="width:12%;">
                        <div>Postal Code</div>
                    </th>
                    <th style="width:12%;">
                        <div>AFM</div>
                    </th>
                    
                    <th class="no-after"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(contact, index) in selectedClient.data.contacts" :key="contact.id" v-if="superUser || canViewAllContacts || canViewContact(contact)">
                    
                    
                    <td>{{ contact.name || '' }}</td>
                    <!-- Creator -->
                    <td>{{ contact.phone || '' }}</td>
                    <!-- Manager -->
                    <td>{{ contact.email || '' }}</td>
                    <td>{{ contact.address || '' }}</td>

                    <td>{{ contact.postal || '' }}</td>

                   
                    <td>{{ contact.afm || '' }}</td>
                </tr>
                <tr v-if="!selectedClient.data.contacts || selectedClient.data.contacts.length === 0">
                    <td colspan="6" class="text-center">No contacts available</td>
                </tr>
            </tbody>
        </table>
        <div class="modal fade" id="confirmationModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Επιβεβαίωση Αποθήκευσης</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        Είστε σίγουροι ότι θέλετε να αποθηκευτούν οι αλλαγές;
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="saveChanges" style="border:none">ΑΠΟΘΗΚΕΥΣΗ</button>
                    </div>
                </div>
            </div>
        </div>

        
    </div>
</template>

<script>
import { statusStyle } from '@/status';
import { ref, computed, onMounted, onUnmounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { get, createOrUpdate } from '@/services/clients';
import { useToast } from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import Editor from '@tinymce/tinymce-vue';
import Select2 from 'vue3-select2-component';
import { mapGetters } from 'vuex';
import { getClientsServicesStatusesUsers } from '@/services/projects';


export default {
    components: {
        Editor,
        Select2
    },
    methods: {
        
        canViewProject(project) {
            if (!project) { return false; }
            return localStorage.getItem('current_user_id') == project?.createdBy && this.userPermissionsProjects?.view === 1;
        },

        canViewContact(contact) {
            if (!contact) { return false; }
            return localStorage.getItem('current_user_id') == contact?.createdBy && this.userPermissionsContacts?.view === 1;
        }, 
        canEditClient(client) {
            return this.userPermissionsClients?.edit == 1 && client?.data.createdBy == localStorage.getItem('current_user_id');
        },
        
       
    },
    computed: {
        ...mapGetters({
            getUserPermission: 'getUserPermission',
            getSuperUserPermission: 'getSuperUserPermission',

        }),
        superUser() {
            return this.getSuperUserPermission === 1;
        },
        userPermissionsProjects() {
            return this.getUserPermission('Projects');
        },
        userPermissionsClients() {
            return this.getUserPermission('Clients');
        },
        userPermissionsContacts() {
            return this.getUserPermission('Contacts');
        },
        
        canEditAllClients() {
            return this.userPermissionsClients?.editAll === 1;
        },
        
        canViewAllProjects() {
            return this.userPermissionsProjects?.viewAdmin === 1;
        },
        canViewAllContacts() {
            return this.userPermissionsContacts?.view === 1;
        },

        formattedPhone: {
      get() {
        // Check if phone is a string 'null' and convert it to an empty string
        return this.selectedClient?.data?.phone === 'null' ? '' : this.selectedClient?.data?.phone;
      },
      set(value) {
        // When setting, store the value directly to selectedClient.data.phone
        this.selectedClient.data.phone = value;
      },
    },
      formattedPostal: {
      get() {
        return this.selectedClient?.data?.postal === 'null' ? '' : this.selectedClient?.data?.postal;
      },
      set(value) {
        this.selectedClient.data.postal = value;
      }
    },
    formattedAddress: {
      get() {
        return this.selectedClient?.data?.address === 'null' ? '' : this.selectedClient?.data?.address;
      },
      set(value) {
        this.selectedClient.data.address = value;
      }
    },
    formattedTaxInfo: {
      get() {
        return this.selectedClient?.data?.taxInfo === 'null' ? '' : this.selectedClient?.data?.taxInfo;
      },
      set(value) {
        this.selectedClient.data.taxInfo = value;
      }
    },
    formattedOccupation: {
      get() {
        return this.selectedClient?.data?.occupation === 'null' ? '' : this.selectedClient?.data?.occupation;
      },
      set(value) {
        this.selectedClient.data.occupation = value;
      }
    },
    formattedFoundUs: {
      get() {
        return this.selectedClient?.data?.foundUs === 'null' ? '' : this.selectedClient?.data?.foundUs;
      },
      set(value) {
        this.selectedClient.data.foundUs = value;
      }
    },
    formattedEmail: {
      get() {
        return this.selectedClient?.data?.email === 'null' ? '' : this.selectedClient?.data?.email;
      },
      set(value) {
        this.selectedClient.data.email = value;
      }
    }
  

    },
    name: 'ClientProfile',
   
    setup() {
        const route = useRoute();
        const selectedClient = ref({
        data: {
            title: '',
            nickname: '',
            email: '',
            occupation: '',
            address: '',
            postal: '',
            phone: '',
            foundUs: '',
            taxInfo: '',
            paid: '',
            potential: '',
            avatar_file_name: '',
            payManagerId: ''

        }
    }); 
        const editableClient = ref({});
        const isEditing = ref(false);
        const toast = useToast();
        const specialtiesOptions = ref([]);
        const selectedSpecialties = ref([]);
        const selectedJobCategories = ref([]);
        const avatar = ref('');
        const avatarUrl = ref('');
        const allData = ref({});

        const onFileChange = (event) => {
            const file = event.target.files[0];
            if (file) {
                avatar.value = file;
                const reader = new FileReader();
                reader.onload = (e) => {
                    avatarUrl.value = e.target.result; // Update preview URL
                };
                reader.readAsDataURL(file);
            }
        };

        const fetchClient = async () => {
            try {
                const response = await get({ id: route.query.id });
                if (response.data) {
                    selectedClient.value = response.data;
                 
                } else {
                    toast.error('Failed to load client profile.');
                }
            } catch (error) {
                toast.error('An error occurred while fetching the client profile.');
            }
        };

        const startEditing = () => {
            editableClient.value = { ...selectedClient.value.data };
            isEditing.value = true;
        };

        const cancelEditing = () => {
            isEditing.value = false;
        };

        const openConfirmationModal = () => {
            $('#confirmationModal').modal('show');
        };

      
        const getStatusStyle = (id) => statusStyle(id, 'min-width:9em; height:2.5em;');

        const statuses = ref([]);


        const getCurrentStatus = (id) => {
            const status = statuses.value.find(s => s.id === id);
            return status ? status.description : 'Select Status';
        };
        const saveChanges = async () => {
            try {
                const formData = new FormData();
                formData.append('id', route.query.id );
                formData.append('title', selectedClient.value.data.title);
                formData.append('nickname', selectedClient.value.data.nickname);
                formData.append('email', selectedClient.value.data.email);
                formData.append('occupation', selectedClient.value.data.occupation);
                formData.append('foundUs', selectedClient.value.data.foundUs);
                formData.append('address', selectedClient.value.data.address);
                formData.append('postal', selectedClient.value.data.postal);
                formData.append('phone', selectedClient.value.data.phone);
                formData.append('taxInfo', selectedClient.value.data.taxInfo);
                formData.append('paid', selectedClient.value.data.paid);
                formData.append('potential', selectedClient.value.data.potential);
                formData.append('payManagerId', selectedClient.value.data.payManagerId);
                formData.append('notes', '');

                if (avatar.value) {
                    formData.append('avatar_file', avatar.value);
                }
    
                const response = await createOrUpdate(formData);

                if (response.data.success) {
                    isEditing.value = false;
                    toast.success(response.data.message.message);
                    fetchClient();
                } else {
                    toast.error(response.data.message);
                }
                $('#confirmationModal').modal('hide');
            } catch (error) {
                console.log(error);
            }
        };

        onMounted(async () => {
            
            fetchClient();
            const tmpAllData = await getClientsServicesStatusesUsers();
            let newData = { users: [], statuses: [], clients: [], services: [] };
            for (let i = 0; i < tmpAllData.data.users.length; i++) {
                newData.users.push({ id: tmpAllData.data.users[i].id, text: tmpAllData.data.users[i].username });
            }
            allData.value = newData;

        });

        return {
            avatar,
            avatarUrl,
            specialtiesOptions,
            selectedClient,
            editableClient,
            isEditing,
            selectedSpecialties,
            selectedJobCategories,
            startEditing,
            cancelEditing,
            openConfirmationModal,
            saveChanges,
            onFileChange,
            getStatusStyle,
            getCurrentStatus,
            allData
        };
    }
};
</script>

<style scoped>
.button-container {
    text-align: right;
    /* Align buttons to the right */
    margin-bottom: 10px;
}

.form-group {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    /* Add spacing between form rows */
}

.form-group label {
    flex: 0 0 150px;
    /* Label takes a fixed width */
    margin-right: 10px;
    /* Add space between label and input */
    font-weight: bold;
    /* Make the label bold to match the style of the static text */
}

.form-group input {
    flex: 0 0 400px;
    /* Set the input width to 200px (adjust as necessary) */
    min-width: 130px;
background-color: white;}

.edit,
.edit:hover {
    background-color: #8d22a2;
    color: white;
}

.save,
.save:hover {
    background-color: #8d22a2;
    color: white;
    margin-right: 10px;
}

.cancel,
.cancel:hover {
    background-color: #dc3545;
    color: white;
    margin-right: 10px;
}

.card.selected-card {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

tr.selected,
div.selected {
    background: #b1afaf;
}

.modal.show .modal-dialog {
    z-index: 1050;
}

.modal-backdrop.show {
    z-index: 1040;
}

.symmetrical-columns {
    display: flex;
    justify-content: space-between;
    gap: 20px;
}

.form-column {
    flex: 1;
}

.form-group,
.form-column p {
    margin-bottom: 15px;
}

.form-group label,
.form-column p strong {
    display: block;
    margin-bottom: 5px;
    font-weight: bold;
}

.form-group input {
    width: 100%;
    padding: 8px;
    box-sizing: border-box;
}

.form-group .input{
    width: 100%;
    padding: 8px;
    box-sizing: border-box;
}

.file-upload-section {
    margin-top: 20px;
}
.button-container {
    text-align: right;
    margin-bottom: 10px;
}

.form-group {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}


.symmetrical-columns {
    display: flex;
    justify-content: space-between;
    gap: 20px;
}

.form-column {
    flex: 1;
}

.edit, .save {
    color: white;
}

.cancel {
    background-color: #dc3545;
    color: white;
}

.form-group{
  border-bottom: 1px solid lightgray;
  padding: 8px 8px 8px 0px;
  width:70%;
}

.client-info {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-top: 20px;
  }
  .info-row {
    display: flex;
    gap: 15px;
    margin-top:15px;
  }
  .info-item {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  label{
    color:#606060;
    font-weight:bolder;
    size:20px;
  }
  input, textarea, select {
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 5px;
    background: #EBEBEB;
  }

  .select2-container--default .select2-selection--multiple .select2-selection__choice {
    background-color: #007bff;
    border-color: #007bff;
    color: #fff;
}
.actions {
    display: flex;
    margin-top: 20px;
    justify-content: flex-end;
  }
  .edit-btn, .cancel-btn {
    
    border: none;
    cursor: pointer;
    margin-right: 10px;
  }
  .edit-btn, .save-btn {
    background-color: #7F7F7F;
    color: white;
    font-weight:bolder;
    border:none;
    padding:10px;
    padding-left:20px;
    padding-right: 20px;
  }
  .cancel-btn {
    border:  #8C8C8C 2px solid;
    background: none;
    color:#8C8C8C;
    font-weight: bolder;
  }

  button{
    border-radius:5px;
  }

  .enabled{
    background-color: white;
  }

  .centered-text {
    text-align: center;
    vertical-align: middle;
}

</style>